import { useContext } from 'react';

import { K8sProvider } from '@cast/shared-types';

import { SelectProviderRadio } from 'components/cluster/SelectProviderRadio';

import { OnboardClusterContext } from '../../../../../OnboardClusterProvider';

import { Typography, Box, Stack } from '@cast/design-system';

const SUPPORTED_PROVIDERS: (keyof typeof K8sProvider)[] = [
  'EKS',
  'GKE',
  'AKS',
  'ROSA',
  'ANYWHERE',
];

export const SelectProvider = () => {
  const { provider, setProvider } = useContext(OnboardClusterContext);

  return (
    <Stack gap={12}>
      <Typography variant="h6">Cloud provider</Typography>

      <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={8}>
        {SUPPORTED_PROVIDERS.map((providerKey) => (
          <SelectProviderRadio
            isCompact
            key={providerKey}
            checked={provider === K8sProvider[providerKey]}
            onClick={() => setProvider(K8sProvider[providerKey])}
            provider={K8sProvider[providerKey]}
            testId={`select-provider-${K8sProvider[providerKey]}`}
          />
        ))}
      </Box>
    </Stack>
  );
};
